module.exports = __webpack_public_path__ + "assets/mp3/audio5/audio_5_2b.mp3";